import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=5398dd08&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=5398dd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5398dd08",
  null
  
)

export default component.exports